export default "__VITE_ASSET__bsUfbU94__"